import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=762fb1fb&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=762fb1fb&prod&lang=scss&scoped=true&external"
import style1 from "./transfer.vue?vue&type=style&index=1&id=762fb1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762fb1fb",
  null
  
)

export default component.exports